import React, { useEffect } from 'react';
import { Text } from '@wix/design-system';
import s from './FallbackWidget.module.scss';
export const FallbackWidget = _ref => {
  let {
    context,
    data
  } = _ref;
  const t = context == null ? void 0 : context.t;
  const errorsMap = {
    400: t('Assistant.platform.error.400'),
    401: t('Assistant.platform.error.401'),
    403: t('Assistant.platform.error.403'),
    404: t('Assistant.platform.error.404'),
    408: t('Assistant.platform.error.408'),
    429: t('Assistant.platform.error.429'),
    500: t('Assistant.platform.error.500'),
    502: t('Assistant.platform.error.502'),
    503: t('Assistant.platform.error.503'),
    504: t('Assistant.platform.error.504'),
    legal: t('Assistant.platform.legal'),
    relevancy: t('Assistant.platform.legal.relevancy')
  };
  const getErrorText = errorCode => {
    return errorsMap[errorCode] || t('Assistant.platform.error.default');
  };
  const {
    errorType,
    errorCode
  } = data;
  useEffect(() => {
    if (context != null && context.onWidgetAction) {
      context.onWidgetAction(FALLBACK_WIDGET, {
        action: 'appeared'
      });
      context.onWidgetAction(FALLBACK_WIDGET, {
        action: 'error',
        value: {
          code: errorCode,
          type: errorType
        }
      });
    }
  }, []);
  const rephrasedError = getErrorText(errorCode);
  return /*#__PURE__*/React.createElement(Text, {
    className: s.text
  }, rephrasedError);
};
export const FALLBACK_WIDGET = 'FALLBACK_WIDGET';
//# sourceMappingURL=FallbackWidget.js.map